export const SELECT_OPTIONS = [
    {value:"all", label: "All"},
    {value:"businessAdministration", label: "Business Administration"},
    {value:"userManagement", label: "User Management"},
    {value:"salesCloud", label: "Sales Cloud"},
    {value:"dataImporting", label: "Data Importing"},
    {value:"flow", label: "Flow"},
    {value:"lightning", label: "Lightning"},
    {value:"security", label: "Security"},
    {value:"approvalProcess", label: "Approval Process"},
    {value:"serviceCloud", label: "Service Cloud"},
    {value:"reporting", label: "Reporting"},
    {value:"agentforce", label: "Agentforce"},
    {value:"AI", label: "AI"},
    {value:"declarativeAutomation", label: "Declarative Automation"},
    {value:"processes", label: "Processes"},
    {value:"salesforcePlatform", label: "Salesforce Platform"},
    {value:"legacy", label: "Legacy"},
];